import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { mergeMap} from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { CashCloseInfo, ReturnsInfo } from 'src/app/models/models';
import { Bank_Movement, Billing_Data, Withdrawal, Currency_Rate, Fund, Payment, Store, User} from 'src/app/models/RestModels';
import { BaseComponent } from '../base/base.component';

interface Equivalencia{
	total:number;
	currency_id:string;
	equivalencia:number;
}

@Component({
	selector: 'app-print-cash-closing3',
	templateUrl: './print-cash-closing3.component.html',
	styleUrls: ['./print-cash-closing3.component.css']
})
export class PrintCashClosing3Component extends BaseComponent implements OnInit
{

	cash_close_info:CashCloseInfo = null;
	current_date:Date = new Date();

	total_sales:number			= 0;
	total_credit:number			= 0;
	total_discount:number		= 0;

	item_total:number			= 0;
	currencies_total:number		= 0;
	total_income_sales:number	= 0;
	total_income_other:number	= 0;
	total_order_amount_paid:number = 0;
	order_counter:number		= 0;
	total_caja:number			= 0;
	total_funds:number			= 0;
	total_expenses				= 0;
	total_withdrawals			= 0;
	withdrawals:Withdrawal[] = [];
	expenses_paymens:Payment[] = [];
	print_and_close:boolean = true;
	print_listener = ()=>{ window.close() };
	store:Store = GetEmpty.store();
	user:User = GetEmpty.user();

	returns_info_list: ReturnsInfo[] = [];
	total_returns: number = 0;

	beforeprint	=()=>
	{
		console.log('beforeprint');
    console.log('CONFIG', this.rest.printer_ticket_config );
		if(	this.rest.printer_ticket_config	)
		{
			document.getElementById('print-config').innerHTML	=	this.rest.printer_ticket_config;
			return;
		}

		document.getElementById('print-config').innerHTML	=	'';
	};

	afterprint	=	function(){
		console.log('afterprint');
		document.getElementById('print-config').innerHTML	=	'';
	};




	d:number = Math.random();

	currency_rate:Currency_Rate = {
		id: 0,
		rate: 19,
		store_id: 0,
		currency_id: 'USD'
	}

	movements_qtys:Record<string,Equivalencia> = {
		'Tarjeta Crédito':{ total: 0, currency_id:'MXN', equivalencia: 0	},
		'Tarjeta Débito':{ total: 0, currency_id:'MXN', equivalencia: 0	},
		Transferencia:{ total: 0, currency_id:'MXN', equivalencia: 0	}
	};

	expense_movements_qtys:Record<string,Equivalencia> = {};

	expense_legend = {
		'CASH':'Efectivo',
		'CREDIT_CARD':'Tarjeta Crédito',
		'DEBIT_CARD':'Tarjeta Débito',
		'CHECK':'Cheque',
		'TRANSFER':'Transferencia',
		'DIGITAL_WALLET':'Monedero',
		'PAYPAL':'PayPal',
		'COUPON':'Cupón',
		'RETURN_DISCOUNT':'Devolución',
	}

	legend = {
		'CASH-MXN':'Efectivo',
		'CASH-USD':'Dolares',
		'CREDIT_CARD-MXN':'Tarjeta Crédito',
		'DEBIT_CARD-MXN':'Tarjeta Débito',
		'CHECK-MXN':'Cheque',
		'TRANSFER-MXN':'Transferencia',
		'DIGITAL_WALLET-MXN':'Monedero',
	}

	payment_movements:Bank_Movement[] = [];
	billing_data:Billing_Data | null = null;

	ngOnInit(): void
	{
		window.addEventListener('beforeprint'	,	this.beforeprint);
		window.addEventListener('afterprint'	,	this.afterprint	);

		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((paramMap)=>
			{
				this.print_and_close = paramMap.has('cerrar');
				return this.rest.cash_close_info.get( paramMap.get('id') )
			})
			,mergeMap((response)=>
			{

				this.rest.printer_ticket_config	=	response.store.printer_ticket_config;

				if( response.store?.default_billing_data_id )
				{

					return forkJoin
					({
						default_billing_data: this.rest.billing_data.get( response.store.default_billing_data_id),
						cash_close_info: of( response )
					})
				}
				else
				{
					return forkJoin
					({
						default_billing_data: of( null ),
						cash_close_info: of( response )
					})
				}
			})
			,mergeMap((response)=>
			{
				this.billing_data = response.default_billing_data;
				return of( response.cash_close_info );
			})
		)
		.subscribe((response)=>
		{
			this.current_date = new Date();
			this.cash_close_info = response;

			this.user = response.user;

			this.total_sales	= 0;
			this.total_credit	= 0;
			this.total_discount = 0;

			this.order_counter	= 0;
			this.item_total		= 0;
			this.total_expenses	= 0;
			this.total_withdrawals = 0;

			this.total_income_sales = 0;
			this.total_income_other = 0;
			this.total_order_amount_paid = 0;
			this.expense_movements_qtys = {};

			this.store = response.store;

			let tmp_payments:Payment[] = [];

			let currency_rate = this.cash_close_info.currency_rates.find(i=>i.currency_id == 'USD' && i.store_id == this.user.store_id )

			if( currency_rate )
				this.currency_rate = currency_rate;

			this.cash_close_info.payments.forEach((payment)=>
			{
				if( payment.type ==	'income' )
				{
					if( payment.tag == 'SALE' )
					{
						this.total_income_sales += payment.payment_amount;
					}
					else
					{
						this.total_income_other += payment.payment_amount;
					}
				}
				else
				{
					tmp_payments.push(payment);
				}
			})

			this.expenses_paymens = tmp_payments;

			this.withdrawals = this.cash_close_info.withdrawals || [];
			this.total_withdrawals = this.withdrawals.reduce((sum:number, w:Withdrawal)=>
			{
				return sum + (w.amount || 0);
			}, 0);

			this.cash_close_info.orders.forEach((order)=>
			{
				this.total_sales 				+= order.total;
				this.total_discount				-= order.discount;
				this.total_order_amount_paid	+= order.amount_paid;
				this.total_credit				+= ((order.total-order.discount) - order.amount_paid );
			});

			this.cash_close_info.item_sales.forEach((x)=>{
				if( x.type != 'REFUND' )
					this.item_total += x.total;
			});

			this.total_funds = this.cash_close_info.funds.reduce((prev:number,fund:Fund)=>
			{
				return prev+fund.amount;
			},0);

			let expenses_excluded_types = ['CREDIT_CARD','DEBIT_CARD','TRANSFER','CHECK','DIGITAL_WALLET','PAYPAL','COUPON'];

			this.cash_close_info.movements.forEach((bm:Bank_Movement)=>
			{
				if( bm.type == 'income' )
				{
					let key = this.legend[ bm.transaction_type+'-'+bm.currency_id ];

					if( !(key in this.movements_qtys) )
					{
						this.movements_qtys[key] = { total: 0, currency_id:bm.currency_id, equivalencia: 0 };
					}

					if( this.movements_qtys[key].currency_id == 'USD' )
					{
						let total = bm.total*this.currency_rate.rate;

						this.movements_qtys[key].equivalencia += total;
						this.movements_qtys[key].total+= bm.total;
						this.currencies_total	+= total;
					}
					else
					{
						this.movements_qtys[key].equivalencia += bm.total;
						this.movements_qtys[key].total+= bm.total;
						this.currencies_total	+= bm.total;
					}
				}
				else
				{
					let key = this.expense_legend[ bm.transaction_type ] || bm.transaction_type;

					if( !(key in this.expense_movements_qtys) )
					{
						this.expense_movements_qtys[key] = { total: 0, currency_id: bm.currency_id, equivalencia: 0 };
					}

					this.expense_movements_qtys[key].total += bm.total;
					this.expense_movements_qtys[key].equivalencia += bm.total;

					if( !expenses_excluded_types.includes(bm.transaction_type) )
					{
						this.total_expenses += bm.total;
					}
				}
			});

			this.cash_close_info = response;

			if (this.cash_close_info.orders && this.cash_close_info.orders.length > 0) 
				{
					let order_ids = this.cash_close_info.orders.map(order => order.id);
				
					this.returns_info_list = [];
					this.total_returns = 0;
				
					let orders = order_ids.map(order_id => 
						this.rest.returns_info.search({ search_extra: { order_id } })
					);
				
					this.subs.sink = forkJoin(orders).subscribe(
						responses => 
						{
							responses.forEach(response => 
							{
								let returns_data: ReturnsInfo[] = response.data || [];
								this.returns_info_list.push(...returns_data);
				
								this.total_returns += returns_data.reduce((sum, ret) => sum + ret.returns.total, 0);
							});
						},
						error => this.showError('Error obteniendo cancelaciones para las órdenes')
					);
				}

			if( this.print_and_close )
			{
				setTimeout(()=>{
					console.log('Printing',this.d);
					window.print();
					this.rest.logout(false);
					window.close();
				},700);
			}
		},this.showError);
	}

	ngOnDestroy()
	{
		window.removeEventListener('beforeprint',	this.beforeprint);
		window.removeEventListener('afterprint',	this.afterprint);
		super.ngOnDestroy();
	}

	printDirect()
	{
		window.print();
	}

	getExpensesTotal(): number
	{
		return Object.keys(this.expense_movements_qtys).reduce((sum, key) =>
		{
			return sum + (this.expense_movements_qtys[key].total || 0);
		}, 0);
	}
}
